import React from 'react';

export const XmartlabsLogo = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="56" fill="#EE1A64" />
    <path
      d="M30.9787 18.4684L0 49.4472V56.0004H6.55319L37.5319 25.6174V46.4684H46.4681V8.93652H8.93617V18.4684H30.9787Z"
      fill="white"
    />
  </svg>
);
